import type { OsmGroupAssignment } from './osm-group-mapping';

/**
 * Filtra las asignaciones cuyo osmId ha sido excluido explícitamente en
 * Modo Edición ("este semáforo no es de este grupo") — actúa sobre el
 * mapeo YA resuelto (automático de gen-osm-mapping.py + manual de
 * group_wiring), sin importar de cuál de los dos venía la asignación.
 */
export function applyGroupWiringExclusions(
  base: OsmGroupAssignment[],
  excludedOsmIds: number[],
): OsmGroupAssignment[] {
  if (excludedOsmIds.length === 0) return base;
  const excluded = new Set(excludedOsmIds);
  return base.filter(m => !excluded.has(m.osmId));
}
